import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const TimeNav: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth() as any;

  const linkClass = (path: string) =>
    `pb-2 text-sm font-medium border-b-2 ${
      location.pathname === path
        ? 'border-naviter-blue text-naviter-blue'
        : 'border-transparent text-gray-500 hover:text-gray-700'
    }`;

  return (
    <div className="flex items-center gap-4 border-b border-gray-200 mb-6">
      <Link to="/time" className={linkClass('/time')}>
        Time Tracker
      </Link>
      {user?.time_master && (
        <Link to="/time/projects" className={linkClass('/time/projects')}>
          Projects
        </Link>
      )}
      <Link to="/stats/time" className={linkClass('/stats/time')}>
        Statistics
      </Link>
    </div>
  );
};

export default TimeNav;
